module.exports = __webpack_public_path__ + "img/type3-1.5dc09e5a.png";